'use client';

import { Box, Typography } from '@mui/material';

import { useT } from '@/hooks';

interface GameListHeaderProps {
  date: string;
  columnVisibility: {
    hasMoneyline: boolean;
    hasSpread: boolean;
    hasTotal: boolean;
  };
}

export const GameListHeader = ({ date, columnVisibility }: GameListHeaderProps) => {
  const { hasMoneyline, hasSpread, hasTotal } = columnVisibility;
  const { t } = useT();
  const visibleColumnsCount = [hasMoneyline, hasSpread, hasTotal].filter(Boolean).length;

  const totalWidth = visibleColumnsCount * 120 + (visibleColumnsCount - 1) * 8;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: 2,
      }}
    >
      <Typography sx={{ fontSize: '1.25rem', fontWeight: 700, color: 'text.primary', flex: 1 }}>
        {date}
      </Typography>

      {visibleColumnsCount > 0 && (
        <Box
          sx={{
            display: { xs: 'none', md: 'flex' },
            gap: 1,
            width: totalWidth,
            justifyContent: 'flex-end',
          }}
        >
          {hasMoneyline && (
            <Typography
              sx={{
                fontSize: '0.75rem',
                fontWeight: 700,
                color: 'text.secondary',
                width: 120,
                textAlign: 'center',
                letterSpacing: '0.05em',
                opacity: 0.8,
              }}
            >
              {t('sports.moneyline')}
            </Typography>
          )}
          {hasSpread && (
            <Typography
              sx={{
                fontSize: '0.75rem',
                fontWeight: 700,
                color: 'text.secondary',
                width: 120,
                textAlign: 'center',
                letterSpacing: '0.05em',
                opacity: 0.8,
              }}
            >
              {t('sports.spread')}
            </Typography>
          )}
          {hasTotal && (
            <Typography
              sx={{
                fontSize: '0.75rem',
                fontWeight: 700,
                color: 'text.secondary',
                width: 120,
                textAlign: 'center',
                letterSpacing: '0.05em',
                opacity: 0.8,
              }}
            >
              {t('sports.total')}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};
